import React from 'react'

import FormHelperText from '@mui/material/FormHelperText'
import { useTheme } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

export default function CustomTextField({
  id,
  type,
  label,
  register,
  placeholder,
  style,
  error,
  helperText,
}) {
  const { spacing } = useTheme()
  return (
    <div style={{ padding: spacing(2, 0), ...style }}>
      <Typography variant="caption" color={Boolean(error) ? 'error' : 'textSecondary'}>
        {label}
      </Typography>
      <TextField
        id={id}
        color="secondary"
        variant="standard"
        {...register}
        type={type || 'string'}
        required
        fullWidth
        placeholder={placeholder}
        InputLabelProps={{ shrink: false }}
        error={Boolean(error)}
      />
      {Boolean(helperText) && <FormHelperText style={{ marginLeft: 0 }}>{helperText}</FormHelperText>}
      {Boolean(error) && <FormHelperText error style={{ marginLeft: 0 }}>{error.message}</FormHelperText>}
    </div>
  )
}
